<template>
    <div>
            <div class="form-group">
                <label>
                    Number of people
                </label>
                <select v-model="peopleCount" class="form-control">
                    <option v-for="n in parseInt(maxPeopleCount, 10)" :key="n" :value="n">{{ n }}</option>
                </select>
            </div>

        <div class="people-selectors">
            <people-selector-single
                v-for="n in parseInt(peopleCount)"
                :key="n"
                :personNumber="n"
                :session="session"
                v-if="internalValue[n - 1]"
                v-model="internalValue[n - 1]"
                class="mb-3" />
        </div>
    </div>
</template>

<script>
    import PeopleSelectorSingle from "./single-selector";
    import * as MutationTypes from '@/store/mutation-types';

    export default {
        name: 'people-selector',
        components: {
            PeopleSelectorSingle
        },
        props: {
            value: {
                type: Array,
            },
            session: {
                type: Object
            }
        },
        mounted() {
            this.peopleCount = Math.max(1, Math.min(3, this.value.length));

            for (let i = 0; i < this.peopleCount; i++) {
                this.internalValue[i] = this.value[i];
            }
        },
        watch: {
            peopleCount() {
                for (let i = 0; i < this.peopleCount; i++) {
                    if (!this.internalValue[i]) {
                        this.internalValue[i] = {};
                    }
                }

                if (this.peopleCount === 1) {
                    // Make sure we unset the adult as we no longer want them to be valid
                    this.$store.commit(MutationTypes.SET_SCENARIO_ACTIVE_ADULT, null);
                }

                this.internalValue = this.internalValue.slice(0, this.peopleCount);
            },
            internalValue: {
                handler(internalValue) {
                    //console.log('internalValue', internalValue);

                    this.$emit('input', internalValue);
                },
                deep: true
            }

        },
        data() {
            return {
                maxPeopleCount: 2,

                peopleCount: 0,
                internalValue: [null, null, null]
            }
        },
    }
</script>
